'use strict';

import React, { Component } from 'react'

import Layout   from '@Layout/BackOffice'

import DataList from '@/DataList'

import _config from '@Config/Blog/blog'

import _ from 'lodash'

let config = _.cloneDeep(_config);

config.header_map['Désactivé'] = 'disabled';

config.field_hook = config.field_hook || { };

config.field_hook['Désactivé'] = function (value)
{
	return [true, 'true'].includes(value) ? 'oui' : '';
};

const app = window.app;

export default class AdminBlogsListPage extends Component
{
	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props;

		config.filter_query =
		{
			type: 'synergies'
		};

		var output =
		(
			<Layout history={ props.history } page_title={ config.title }>

				<div className="page-content">

					<div className="o-content">
						<DataList config={ config } history={ props.history } />
					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}
